import { ICalendarProps, IStaffCalendarFilterData } from "@/api_framework/api_modals/Calendar";
import { IClinicListResponseData } from "@/api_framework/api_modals/Clinics";
import { IOrgCityListResponseData, IOrgProviderListResponseData } from "@/api_framework/api_modals/Org";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";

export interface ICalendarState {
  clinics?: IClinicListResponseData[] | null;
  expandedView: boolean;
  cities?: IOrgCityListResponseData[] | null;
  providers?: IOrgProviderListResponseData[] | null;
  calendarProviders?: IOrgProviderListResponseData[] | null;
  calendarFilter?: ICalendarProps | null;
  gridView?: boolean;
  calendarData?: IStaffCalendarFilterData[] | null;
}
export interface ICalendarViewInitialState extends IRouteReducerSliceStateInit {
  state: ICalendarState;
}

const initialState: ICalendarViewInitialState = {
  state: {
    expandedView: false,
    gridView: false,
    providers: [],
    calendarFilter: null,
    calendarData: [],
    calendarProviders: [],
  },
};

const viewCalendarStateSlice = createSlice({
  name: "calendar_slice",
  initialState: initialState,
  reducers: {
    setCALENDAROrgCities: (
      state,
      action: PayloadAction<{
        data: IOrgCityListResponseData[];
      }>,
    ) => {
      state.state.cities = action.payload.data;
    },
    setExpandedView: (state, action: PayloadAction<boolean>) => {
      state.state.expandedView = action.payload;
    },
    setCalendarGridView: (state, action: PayloadAction<boolean>) => {
      state.state.gridView = action.payload;
    },
    setCALENDAROrgProviders: (
      state,
      action: PayloadAction<{
        data: IOrgProviderListResponseData[];
      }>,
    ) => {
      state.state.providers = action.payload.data;
    },
    setCalendarProviders: (
      state,
      action: PayloadAction<{
        data: IOrgProviderListResponseData[];
      }>,
    ) => {
      state.state.calendarProviders = action.payload.data;
    },
    setCALENDAROrgClinics: (
      state,
      action: PayloadAction<{
        data: IClinicListResponseData[];
      }>,
    ) => {
      state.state.clinics = action.payload.data;
    },
    setCalendarFilter: (
      state,
      action: PayloadAction<{
        data: ICalendarProps;
      }>,
    ) => {
      state.state.calendarFilter = action.payload.data;
    },
    setCalendarData: (state, action: PayloadAction<{ data: IStaffCalendarFilterData[] }>) => {
      state.state.calendarData = action.payload.data;
    },
  },
});

export const {
  setCALENDAROrgClinics,
  setCALENDAROrgProviders,
  setCALENDAROrgCities,
  setExpandedView,
  setCalendarFilter,
  setCalendarData,
  setCalendarGridView,
  setCalendarProviders,
} = viewCalendarStateSlice.actions;
export default viewCalendarStateSlice.reducer;
